export const ALLOWED_SHINGLE_UIDS = ['trudefinition-duration', 'trudefinition-duration-designer'];

export const ALLOWED_LOCALES = ['en-US'];

export const CONTENT_AND_IMAGE_REUSABLE = {
  name: 'Order Samples',
  path: 'roofing',
};

export const ORDER_SAMPLES_IMAGE_URL =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/w_270/v1682686097/roofing/shingles/order-samples.jpg';
